// ! movie player - check for Edge
export const isPlayerEnabled = () => {
    const agent = window.navigator.userAgent.toLowerCase();
    return (
        agent.indexOf('chrome') > -1 || //chrome
        agent.indexOf('edge') > -1 || // edge
        agent.indexOf('edg/') > -1 || // edge chromium
        agent.indexOf('trident') > -1 // ie
    );
};
// !
